import * as React from "react";
import { SVGProps } from "react";
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 14h-2.231a8.942 8.942 0 0 0-1.156-2.785l1.579-1.579a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-1.579 1.579A8.943 8.943 0 0 0 18 7.231V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2.231a8.943 8.943 0 0 0-2.785 1.156L9.636 6.808a.999.999 0 0 0-1.414 0L6.808 8.222a.999.999 0 0 0 0 1.414l1.579 1.579A8.943 8.943 0 0 0 7.231 14H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2.231a8.943 8.943 0 0 0 1.156 2.785l-1.579 1.579a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l1.579-1.579c.856.54 1.798.931 2.785 1.156V27a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2.231a8.942 8.942 0 0 0 2.785-1.156l1.579 1.579a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-1.579-1.579A8.942 8.942 0 0 0 24.769 18H27a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm-11 6a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSettings;
